exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo-trigger .demo[data-v-c923bff0]{display:none;position:absolute;z-index:1000;margin-top:.4em}.demo-trigger:hover .demo[data-v-c923bff0]{display:block}.demo-trigger .demo img[data-v-c923bff0]{height:24em}", ""]);

// exports
